import React, { PureComponent } from 'react';

import { TextField } from '@mui/material';
import { QueryEditor } from '../QueryEditor/QueryEditor';

class FleetEditor extends PureComponent {
  render() {
    if (this.props.filters.length === 0) return <div />;
    return (
      <div>
        <TextField
          variant="standard"
          data-qa="qa-editFleetName"
          label="Fleet name"
          error={this.props.fleetNameErrorText !== ''}
          helperText={this.props.fleetNameErrorText}
          style={{ width: '100%' }}
          value={this.props.fleet.Name}
          margin="normal"
          onChange={(event) => this.props.onChangeCallback('Name', event.target.value)}
        />
        <QueryEditor
          filters={this.props.filters}
          query={JSON.parse(this.props.fleet.Query)}
          onChange={(query) => this.props.onChangeCallback('Query', JSON.stringify(query))}
          queryLevel={3}
        />
      </div>
    );
  }
}

export default FleetEditor;
